module.exports = __webpack_public_path__ + "img/upgrade7.38ddf6c0.png";